import { xAdd, xMaxValue } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function setMaxY(data, options = {}) {
    const { max = 1 } = options;
    const existingMax = xMaxValue(data.y);
    if (existingMax === max) {
        return { data };
    }
    return {
        data: {
            x: data.x,
            y: xAdd(data.y, max - existingMax),
        },
    };
}
//# sourceMappingURL=setMaxY.js.map